module.exports = __webpack_public_path__ + "img/DI_MV.7122bc3f.png";